import './styles.css';

import {
  Auth0Provider,
  type Auth0ProviderOptions,
  type CacheLocation
} from '@auth0/auth0-react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { AUTH0_CLIENT_ID, AUTH0_HOST } from './constants/common';

const providerConfig: Auth0ProviderOptions = {
  domain: AUTH0_HOST,
  clientId: AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/authenticate`,
    audience: 'scope2-api-dev',
    scope: 'openid email profile'
  },
  cacheLocation: 'localstorage' as CacheLocation
  // useRefreshTokens: true TODO: Reimplement for extension warning
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth0Provider {...providerConfig}>
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
